function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo",
  x1: 0.413,
  y1: -0.043,
  x2: 0.569,
  y2: 1.174,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.012,
  stopColor: "#34a680"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#005c89"
})));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 28",
  d: "M255.56 242.028a104.071 104.071 0 01-19.123-1.338 1.326 1.326 0 01-1.126-1.259 1.308 1.308 0 01.99-1.34l.829-.225c4.367-1.182 14.6-3.949 17.357-6.667 1.78-1.753 2.516-3.622 2.127-5.4-.456-2.09-2.478-3.973-5.409-5.037-8.976-3.259-19.332-2.809-28.745-3.186q-12.212-.489-24.434-.635c-6.678-.079-14.436.491-20.174-3.654a11.212 11.212 0 01-3.522-14.92c3.471-5.985 13.144-8.075 17.142-8.7a114.143 114.143 0 0114.19-1.385c10.885-.552 15.768.209 25.018-3.732a1.386 1.386 0 011.74.567 1.267 1.267 0 01.007 1.286c-5.472 9.652-23.79 7.612-34.511 11.108-2.516.82-6.772 3.137-6.143 6.447a3.674 3.674 0 001.7 2.29c3.038 1.967 6.917 1.862 10.365 2.059l.23.014c10.083.579 20.355-.188 30.475-.129 12.757.074 25.915-.311 38.547 1.633 7.437 1.144 19.319 3.859 19.489 13.374.168 9.438-12.381 15-17.23 16.346a81.653 81.653 0 01-19.789 2.483z",
  transform: "translate(-172.838 -184.437)",
  fill: "url(#logo)"
});

function SvgLogo(_ref, svgRef) {
  let title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 84,
    height: 42,
    viewBox: "0 0 119.74 57.609",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.741c109f.svg";
export { ForwardRef as ReactComponent };